/* unplugin-vue-components disabled */import { render } from "./UserZfb.vue?vue&type=template&id=7c5e07b0&scoped=true"
import script from "./UserZfb.vue?vue&type=script&lang=js"
export * from "./UserZfb.vue?vue&type=script&lang=js"

import "./UserZfb.vue?vue&type=style&index=0&id=7c5e07b0&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/plp-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c5e07b0"]])

export default __exports__